import React, { Component } from 'react';
import './components/TodoListStyles.css';
import TodoInput from './components/TodoInput';
import TodoList from './components/TodoList';

import storage from 'local-storage-fallback';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import style from 'styled-theming';
import Switch from 'react-switch';
import { ReactComponent as MoonIcon } from './icons/moon_02.svg';
import { ReactComponent as SunIcon } from './icons/sun_5.svg';

import 'bootstrap/dist/css/bootstrap.min.css';
import uuid from 'uuid';


const getBackground = style('mode', {
  light: '#EEE',
  dark: '#111'
});

const getForeground = style('mode', {
  light: '#111',
  dark: '#7afbc5'
});

const GlobalStyle = createGlobalStyle`
  h3#title {
    color:  ${props => props.theme.mode === 'dark' ? '#333333' : '#3333332b'};
  }

  body {
    /*background-color: ${props => props.theme.mode === 'dark' ? '#111' : '#EEE'};
    color: ${props => props.theme.mode === 'dark' ? '#EEE' : '#111'};*/
    background-color: ${getBackground};
    color: ${getForeground};
  }
  .card-body {
    background-color: ${props => props.theme.mode === 'dark' ? '#111' : '#EEE'};
    color: ${props => props.theme.mode === 'dark' ? '#7afbc5' : '#111'};
    border: ${props => props.theme.mode === 'dark' ? '2px solid #333' : '2px solid #d8d8d8'};
  }

  li.d-flex.justify-content-between.list-group-item.my-2.text-capitalize,
  input.form-control.text-capitalize,
  textarea.form-control.text-capitalize {
    background-color: ${props => props.theme.mode === 'dark' ? '#1f252b' : '#EEE'};
    color: ${props => props.theme.mode === 'dark' ? '#EEE' : '#111'};
  }

  button.btn.btn-danger.clear-txt {
    border-color: ${props => props.theme.mode === 'dark' ? '#EEE' : '#a20000'};
  }

  div#todo-item-text-completed,
  div#todo-item-completedDT {
    text-decoration-color: ${props => props.theme.mode === 'dark' ? '#ff8c00' : '#0000ff'};
    color: ${props => props.theme.mode === 'dark' ? '#ff8c00' : '#0000ff'};
  }

  /*span.mx-2.item-actions {
    padding: 10px;
  }*/
`;

/*
-->This can be used to display text 
within the toggle switch that's used for the dark/light themes
---------------------------------------
const textSwitch = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  fontSize: 15,
  color: "#fff",
  paddingRight: 2
}*/


class App extends Component {
  state = {
    items: [],
    checkedItems: [],
    id: uuid(),
    item: '',
    editItem: false,
    theme: {mode: 'dark'},
    toggleChecked: false //this is for the dark/light theme changer
  };

  //e is for the event
  //use arrow since don't want to do bindings within the constructor
  //arrow function (=>) does implicit return so don't need to write return when defining a function
  handleChange = (e) => {
    this.setState({
      item: e.target.value
    });
  };

  handleSubmit = () => {
    //e.preventDefault();
    
    if (this.state.item.trim() !== "") {

      //Do the following if todo input is being added for the first time
      if(!this.state.editItem){
      
        const newItem = {
          id: uuid(),
          title: this.state.item,
          isChecked: false,
          completedDate: ''
        }
    
        //cant mutate state of array - state is immutable (can't do something like push into an array)
        //... is the spread operator used to keep track of the items in an array
        const updatedItems = [...this.state.items, newItem];
    
        this.setState({
          items: updatedItems,
          item: '',
          id: newItem.id,
          editItem: false
        });

      } 
      //Do the following if the item is being edited
      else{

        const itemEdited = this.state.items.find(item => item.id === this.state.id);
        itemEdited.title = this.state.item;

        this.setState({
          items: this.state.items,
          item: '',
          editItem: false
        });
      }
    }    
  };

  handleEdit = (id) =>{
    //const filteredItems = this.state.items.filter(item => item.id !== id);
    
    //using controlled input below to handle editing of items
    const selectedItem = this.state.items.find(item => item.id === id);

    this.setState({
      //the id val has to be set to the method's passed in id value
      id: id,
      //below prints the item's title back in the todo input box for editing
      item: selectedItem.title,
      editItem: true
    });
  };

  handleInputReset = () =>{
    if (this.state.item.trim() !== "") {
      this.setState({
        item: '',
        editItem: false
      });
    }
  };

  //Did prop drilling to be able to delete individual todo items
  handleDelete = (id) => {
    const filteredItems = this.state.items.filter(item => item.id !== id);

    if(this.state.editItem){
      this.setState({
        items: filteredItems,
        item: '',
        editItem: false
      });

    } else{
      this.setState({
        items: filteredItems
      });
    }

  };

  determineCompletedAction = () => {

    if(this.state.checkedItems && this.state.checkedItems.length){
      //eslint-disable-next-line
      for(const [checked_index, checked_value] of this.state.checkedItems.entries()){
        this.handleCompleted(checked_value.id);
      }

    }else{
      this.markAllCompleted();
    }
  }

  markAllCompleted = () => {
    const updatedItemsListCopy = Object.assign([], this.state.items);

    if((updatedItemsListCopy).length > 0 
          && window.confirm('Are you sure you wish to mark ALL the to-do items as completed?')){
      if(updatedItemsListCopy && updatedItemsListCopy.length){
        //eslint-disable-next-line
        for(const [index, item] of updatedItemsListCopy.entries()){
          if(item.completedDate.trim() === "") {
            this.handleCompleted(item.id);
          }
        }
      }
    }
  }

  handleCompleted = (id) => {    

    //Constructs the date time value to display for completed todo items
    var date = new Date().getDate(); //Current Date
    var month = new Date().getMonth() + 1; //Current Month
    var year = new Date().getFullYear(); //Current Year
    var hours = new Date().getHours(); //Current Hours
    var min = new Date().getMinutes(); //Current Minutes
    var sec = new Date().getSeconds(); //Current Seconds
    const currDateTime = date + '/' + month + '/' + year + ' ' + hours + ':' + min + ':' + sec;
    
    //Creates a copy of the initial items array
    const updatedItemsListCopy = Object.assign([], this.state.items);
    //Retrieves index value of the item being manipulated
    const completedItemIndex = this.state.items.findIndex(item => item.id === id);
    const completedItem = updatedItemsListCopy.find(item => item.id === id);
    
    //Toggles completed date value per item in the items array
    if(typeof completedItem.completedDate !== "undefined"){
      if(completedItem.completedDate.trim() !== ""){
        completedItem.completedDate = "";
              
      }else{
        completedItem.completedDate = "Completed on - " + currDateTime;
      }
    }

    //Updates the item value in the copied items array
    updatedItemsListCopy[completedItemIndex] = completedItem;

    this.setState({
      items: updatedItemsListCopy
    });

  };

  handleChecked = (id) => {
    
    //Creates a copy of the initial items array
    const updatedItemsListCopy = Object.assign([], this.state.items);
    //Retrieves index value of the item being manipulated
    const checkedItemIndex = this.state.items.findIndex(item => item.id === id);
    const checkedItem = updatedItemsListCopy.find(item => item.id === id);

    var checkedItemList = this.state.checkedItems;

    if(typeof checkedItem.isChecked !== "undefined"){
      if(checkedItem.isChecked === true){
        checkedItem.isChecked = false;
                
        checkedItemList = checkedItemList.filter(checkedItem => checkedItem.id !== id);

      }else{
        checkedItem.isChecked = true;
        
        checkedItemList.push(checkedItem);
      }
    }

    //Updates the item value in the copied items array
    updatedItemsListCopy[checkedItemIndex] = checkedItem;

    //console.log(checkedItem, checkedItemIndex, checkedItem.isChecked);
    //console.log(isAnyItemChecked, checkedItemList);

    this.setState({
      items: updatedItemsListCopy,
      checkedItems: checkedItemList
    });

  };

  determineDeleteAction = () => {
    var updatedItemsListCopy = Object.assign([], this.state.items);

    if(this.state.checkedItems && this.state.checkedItems.length){
      //eslint-disable-next-line
      for(const [checked_index, checked_value] of this.state.checkedItems.entries()){
        updatedItemsListCopy = updatedItemsListCopy.filter(item => item.id !== checked_value.id);
      }

      this.setState({
        items: updatedItemsListCopy,
        checkedItems: []
      });

    }else{
      this.clearList();
    }
  }

  clearList = () => {

    if((this.state.items).length > 0 
          && window.confirm('Are you sure you wish to delete ALL the to-do items?')){
      if(this.state.editItem){
        this.setState({
          items: [],
          item: '',
          editItem: false
        });
  
      } else{
        this.setState({
          items: []
        })
      }
    }
    
  };

  getInitialTheme = () => {
    const savedTheme = storage.getItem('theme');

    this.setState({
      theme: savedTheme
    });

    return savedTheme ? JSON.parse(savedTheme) : { mode: 'light'};
  }

  handleToggleSwitchChange = (toggleChecked) => {
    this.setState({
      toggleChecked: toggleChecked,
      theme: this.state.theme.mode === 'dark' ? {mode: 'light'} : {mode: 'dark'}
    });
  }

  componentDidMount() {
    //storage.setItem('theme', JSON.stringify(this.state.theme));

    if (localStorage.getItem('theme') && localStorage.getItem('isToggleChecked') && localStorage.getItem('todoListItems')) {
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.toggleChecked = JSON.parse(localStorage.getItem('isToggleChecked'));
      this.items = JSON.parse(localStorage.getItem('todoListItems'));

      this.setState({
        toggleChecked: this.toggleChecked,
        theme: this.theme,
        items: this.items
      });

    } else{
      localStorage.clear();

      localStorage.setItem('theme', JSON.stringify(this.state.theme));
      localStorage.setItem('isToggleChecked', JSON.stringify(this.state.toggleChecked));
      localStorage.setItem('todoListItems', JSON.stringify(this.state.items));
    }
  }

  componentDidUpdate() {
    localStorage.clear();

    localStorage.setItem('theme', JSON.stringify(this.state.theme));
    localStorage.setItem('isToggleChecked', JSON.stringify(this.state.toggleChecked));
    localStorage.setItem('todoListItems', JSON.stringify(this.state.items));
  }

  render () {

    return (
      <ThemeProvider theme={this.state.theme}>
        <>          
          <GlobalStyle />

          <div className="container">
            <div className="row">

              <div className="col-10 mx-auto col-md-8 mt-4">
                <h3 id="title" className="text-capitalize text-center">My To-Do List!</h3> 
                
                <Switch className="react-switch" 
                  onChange={this.handleToggleSwitchChange} 
                  checked={this.state.toggleChecked}
                  handleDiameter={28}
                  offColor="#fff"
                  onColor="#000"
                  offHandleColor="#08f"
                  onHandleColor="#08f"
                  height={40}
                  width={100}
                  checkedIcon={
                    <svg viewBox="0 0 10 10" height="100%" width="100%">
                      <MoonIcon />
                    </svg>
                  }
                  uncheckedIcon={
                    <svg viewBox="0 0 10 10" height="100%" width="100%">
                      <SunIcon />
                    </svg>
                  }
                />
               
                <TodoInput item={this.state.item} 
                    handleChange={this.handleChange} 
                    handleSubmit={this.handleSubmit} 
                    editItem={this.state.editItem}
                    handleInputReset={this.handleInputReset}
                />

                <TodoList items={this.state.items} 
                    checkedItems={this.state.checkedItems}
                    determineDeleteAction={this.determineDeleteAction}
                    //clearList={this.clearList} 
                    handleChecked={this.handleChecked}
                    handleEdit={this.handleEdit} 
                    handleDelete={this.handleDelete}
                    handleCompleted={this.handleCompleted}
                    //markAllCompleted={this.markAllCompleted}
                    determineCompletedAction={this.determineCompletedAction}
                />
              </div>
            </div>
          </div>

        </>
      </ThemeProvider>
    );
  }
}

export default App;
